
import { motion, AnimatePresence } from 'framer-motion';

interface PhotoModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const PhotoModal = ({ isOpen, onClose }: PhotoModalProps) => {
  return (
    <AnimatePresence>
      {isOpen && (
        <>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={onClose}
            className="fixed inset-0 bg-black/60 z-50"
          />
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.95 }}
            className="fixed inset-0 z-50 flex items-center justify-center p-4"
          >
            <div className="bg-white rounded-lg shadow-xl max-w-md w-full p-6">
              <div className="flex justify-between items-center mb-4">
                <h3 className="text-xl font-bold text-gray-900">Enviar Fotos del Incendio</h3>
                <button
                  onClick={onClose}
                  className="text-gray-400 hover:text-gray-600 transition-colors"
                  aria-label="Cerrar"
                >
                  <i className="ri-close-line text-2xl"></i>
                </button>
              </div>
              <p className="text-sm text-gray-600 mb-6">
                Envíanos fotos de los daños por WhatsApp para una evaluación más rápida y precisa.
              </p>
              <div className="space-y-3">
                <a
                  href="https://wa.me/34602365996?text=Hola,%20necesito%20presupuesto%20para%20limpieza%20post%20incendio.%20Adjunto%20fotos."
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block w-full px-6 py-3 bg-[#25D366] text-white text-center font-semibold rounded-lg hover:bg-[#1da851] transition-all whitespace-nowrap"
                  onClick={onClose}
                >
                  <i className="ri-whatsapp-line mr-2"></i>
                  Enviar por WhatsApp
                </a>
                <a
                  href="mailto:info@incendios.justclean.es?subject=Solicitud%20de%20Presupuesto%20-%20Limpieza%20Post%20Incendio"
                  className="block w-full px-6 py-3 bg-gray-800 text-white text-center font-semibold rounded-lg hover:bg-gray-700 transition-all whitespace-nowrap"
                  onClick={onClose}
                >
                  <i className="ri-mail-line mr-2"></i>
                  Enviar por Email
                </a>
              </div>
            </div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
};

export default PhotoModal;
